export default __webpack_public_path__ + "static/media/Shipping.79af52dd.jpg";